import { Link } from "react-router-dom";
import { NotFoundPage } from "pages";
import Dashboard from "modules/Dashboard";
import axios from "axios";
import { Branch, Brand, Buying, BuyingDetail, BuyingReport, Category, Customer, CustomerReport, Customer_Detail, Delivery, District, Guidebook, Information, Order, OrderDetails, OrderReport, PaymentType, Product, ProductDetail, ProductReport, Provice, Province, Report, Role, Sector, Seller,  User, UserDetail, UserReport, Vendor, Warehouse, Warehouse_Detail } from "modules";
import Copmany from "modules/Company";
import { Role_Settings, System_Settings } from "modules/Settings";
import { CompanyInfo } from "modules/Organization";
import EditableTable from "modules/editable";
import OrderbuyinReport from "modules/ProfitReport";
import ProfitReport from "modules/ProfitReport";

const routes = [
  {
    name: 'Not Found',
    path: '/*',
    element: <NotFoundPage/>,
  },
  {
    name: 'Not Found',
    path: '/test',
    element: <EditableTable/>,
  },
  {
    name: 'Хянах самбар',
    path: '/',
    element: <Dashboard/>,
  },
  {
    name: 'Ангилал',
    path: '/category',
    element: <Category/>,
    handle: {
      crumb: () => <Link to={'/category'}>Ангилал</Link>
    },
  },
  {
    name: 'Салбар нэгж',
    path: '/branch',
    element: <Branch/>,
    handle: {
      crumb: () => <Link to={'/branch'}>Салбар нэгж</Link>
    },
  },
  {
    name: 'Байгуулга',
    path: '/company',
    element: <CompanyInfo/>,
    handle: {
      crumb: () => <Link to={'/company'}>Байгуулга</Link>
    },
  },
  {
    name: 'Хэрэглэгч',
    path: '/user',
    element: <User/>,
    handle: {
      crumb: () => <Link to={'/user'}>Хэрэглэгч</Link>
    },
  },
  {
    name: 'Брэнд',
    path: '/brand',
    element: <Brand/>,
    handle: {
      crumb: () => <Link to={'/brand'}>Брэнд</Link>
    },
  },
  {
    name: 'Ажилчид',
    path: '/user',
    element: <User/>,
    handle: {
      crumb: () => <Link to={'/user'}>Ажилчид</Link>
    },
  },
  {
    name: 'Ажилчид дэлгэрэнгүй',
    path: '/user/:id',
    element: <UserDetail/>,
    handle: {
      crumb: () => <Link to={'/user/:id'}>Ажилчид дэлгэрэнгүй</Link>
    },
  },

  {
    name: 'Төлбөрийн хэлбэр',
    path: '/payment_type',
    element: <PaymentType/>,
    handle: {
      crumb: () => <Link to={'/payment_type'}>Төлбөрийн хэлбэр</Link>
    },
  },
  {
    name: 'Тайлан',
    path: '/report',
    element: <Report/>,
    handle: {
      crumb: () => <Link to={'/report'}>Тайлан</Link>
    },
  },
  {
    name: 'Тохиргоо',
    path: '/settings',
    element: <System_Settings/>,
    handle: {
      crumb: () => <Link to={'/settings'}>Тохиргоо</Link>
    },
  },
  {
    name: 'Эрхийн тохиргоо',
    path: '/role',
    element: <Role_Settings/>,
    handle: {
      crumb: () => <Link to={'/role-settings'}>Эрхийн тохиргоо</Link>
    },
  },
  {
    name: 'Дүүрэг',
    path: '/district',
    element: <District/>,
    handle: {
      crumb: () => <Link to={'/district'}>Дүүрэг тохиргоо</Link>
    },
  },
  {
    name: 'Аймаг',
    path: '/province',
    element: <Province/>,
    handle: {
      crumb: () => <Link to={'/province'}>Аймаг тохиргоо</Link>
    },
  },
  {
    name: 'Агуулах',
    path: '/warehouse',
    element: <Warehouse/>,
    handle: {
      crumb: () => <Link to={'/warehouse'}>Агуулах</Link>
    },
  },
  {
    name: 'Агуулах дэлгэрэнгүй',
    path: '/warehouse/:id',
    element: <Warehouse_Detail/>,
    handle: {
      crumb: () => <Link to={'/warehouse/:id'}>Агуулахын бараа</Link>
    },
  },
  {
    name: 'Захиалга',
    path: '/order',
    element: <Order/>,
    handle: {
      crumb: () => <Link to={'/order'}>Захиалга</Link>
    },
  },
  {
    name: 'Захиалга',
    path: '/order/:id',
    element: <OrderDetails/>,
    handle: {
      crumb: () => <Link to={'/order/:id'}>Захиалгын дэлгэрэнгүй</Link>
    },
  },
  {
    name: 'Харилцагчийн жагсаалт',
    path: '/customer',
    element: <Customer/>,
    handle: {
      crumb: () => <Link to={'/customer'}>Харилцагчийн жагсаалт</Link>
    },
  },
  {
    name: 'Харилцагчийн мэдээлэл',
    path: '/customer/:id',
    element: <Customer_Detail/>,
    handle: {
      crumb: () => <Link to={'/customer/:id'}>Харилцагчийн мэдээлэл</Link>
    },
  },
  {
    name: 'Татан авагч',
    path: '/buying',
    element: <Buying/>,
    handle: {
      crumb: () => <Link to={'/buying'}>Татан авагч</Link>
    },
  },
  {
    name: 'Татан дэлгэрэнгүй',
    path: '/buying/:id',
    element: <BuyingDetail/>,
    handle: {
      crumb: () => <Link to={'/buying/:id'}>Татан авагч</Link>
    },
  },
  {
    name: 'Нийлүүлэгч',
    path: '/vendor',
    element: <Vendor/>,
    handle: {
      crumb: () => <Link to={'/vendor'}>Нийлүүлэгч</Link>
    },
  },
  {
    name: 'Барааны тайлан',
    path: '/product-report',
    element: <ProductReport/>,
    handle: {
      crumb: () => <Link to={'/product-report'}>Барааны тайлан</Link>
    },
  },
  {
    name: 'Борлуулалтын тайлан',
    path: '/order-report',
    element: <OrderReport/>,
    handle: {
      crumb: () => <Link to={'/order-report'}>Борлуулалтын тайлан</Link>
    },
  },
  {
    name: 'Ажилтны тайлан',
    path: '/user-report',
    element: <UserReport/>,
    handle: {
      crumb: () => <Link to={'/user-report'}>Ажилтны тайлан</Link>
    },
  },
  {
    name: 'Хүргэлт',
    path: '/delivery',
    element: <Delivery/>,
    handle: {
      crumb: () => <Link to={'/delivery'}>Хүргэлт</Link>
    },
  },

  {
    name: 'Харилцагчийн тайлан',
    path: '/customer-report',
    element: <CustomerReport/>,
    handle: {
      crumb: () => <Link to={'/customer-report'}>Харилцагчийн тайлан</Link>
    },
  },
  {
    name: 'Ашиг орлогийн тайлан',
    path: '/order-buying-report',
    element: <ProfitReport/>,
    handle: {
      crumb: () => <Link to={'/order-buying-report'}>Ашиг орлогийн тайлан</Link>
    },
  },
  {
    name: 'Гарын авлага',
    path: '/guidebook',
    element: <Guidebook/>,
    handle: {
      crumb: () => <Link to={'/guidebook'}>Гарын авлага</Link>
    },
  },
    {
      name: 'Мэдээлэл',
      path: '/information',
      element: <Information/>,
      handle: {
        crumb: () => <Link to={'/information'}>Мэдээлэл</Link>
      },
    },
  {
    name: 'Бараа',
    path: '/products',
    handle: {
      crumb: () => <Link to={'/products'}>Бараа</Link>
    },
    children: [
      {
        index: true,
        element: <Product/>
      },
      {
        name: 'Барааны дэлгэрэнгүй',
        path: '/products/:id',
        element: <ProductDetail/>,
        handle: {
          crumb: (e) => <Link to={'/products/id'}>Барааны дэлгэрэнгүй</Link>
        },
       
      },
    ]
  },
]

export default routes